import * as React from 'react';
import styled from 'styled-components';
const layout = (props) => {
    return (React.createElement(LayoutStyle, null, props.children));
};
export default layout;
const LayoutStyle = styled.div `
  color: #fff;
  display: grid;
  grid-gap: 1px;
  grid-template-columns: 300px auto;
  grid-template-rows: auto;
  grid-template-areas:
    "header header"
    "content content"
    "footer footer";
`;
//# sourceMappingURL=Layout.js.map


// WEBPACK FOOTER //
// ./src/components/Layout.js